import { JsonApiPayload, ModelLike } from "./JsonApiPayload";

export class ReservationPayload extends JsonApiPayload {
  id: string;
  parkId: string;
  siteId: string;
  siteTypeId: string;
  guestId: string;
  type: 'Reservation';
  arrivalDate: string;
  departureDate: string;
  adults: number;
  children: number;
  pets: number;
  vehicleType: string;
  vehicleLengthRange: string;
  vehicleSlides: string[];
  vehicleTowing: string;
  vehicleElectrical: string[];
  rateId: string;
  rateType: string;
  monthlyRateStrategy: string;
  rateOverride: number;
  discountId: string;
  discountCode: string;
  loyaltyNumber: string;
  paymentMethodId: string;
  notes: string;
  action: string;

  static new(model?: ModelLike) {
    return super.fill(new this(), model);
  }

  static getSchema() {
    const result = super._getSchema(this, []);
    return result;
  }
}
